function getUrlParameters() {
  const regex = /(\?|&)([^=]+)=([^&]+)/gm;
  var urlParams = window.location.search;
  var match;
  var params: any = {};

  while ((match = regex.exec(urlParams)) !== null) {
    if (match.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    var key = match[2];
    var value = match[3];
    params[key] = value;
  }

  return params;
}

export function getUrlParameterValue(parameter: string) {
  var params = getUrlParameters();
  for (var key in params) {
    if (key.toLowerCase() === parameter.toLowerCase()) {
      return params[key];
    }
  }
  return false;
}
